import React, { Component } from 'react';
import { AxiosHttpClient, Logger } from 'UI-Dash-Commons-UI';


interface AsyncContentComponentProps
{
    requestUrl: string
}

type State = Readonly<{
    content: string
}>;

const TAG = 'AsyncContentComponent';

export default class AsyncContentComponent extends Component<AsyncContentComponentProps, State>
{
    state: State = {
        content: ''
    };

    componentDidMount()
    {
        this.loadContent( this.props.requestUrl );
    }

    loadContent = requestUrl =>
    {
        Logger.info(TAG, `Fetching content from ${requestUrl}...`);

        const client: AxiosHttpClient = new AxiosHttpClient();
        client.get(
            requestUrl,
            ({ content }) => this.setState({ content }),
            errorResponse => console.log( errorResponse )
        );
    };

    render()
    {
        return <span dangerouslySetInnerHTML={{__html: this.state.content}} />
    }
}
